import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";


// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC9lBjm9GPGZl9dXcSm9xpJotXd4Za1ZUs",
  authDomain: "planyt-chat-b2728.firebaseapp.com",
  projectId: "planyt-chat-b2728",
  storageBucket: "planyt-chat-b2728.firebasestorage.app",
  messagingSenderId: "639129213531",
  appId: "1:639129213531:web:b4dc5b339c8279f9aabd7e"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth();
export const storage = getStorage();
export const db = getFirestore()
